import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import ConfirmationPopup from "./Popup";
import router from "next/router";
import { UUID } from "crypto";
import { useAddApplicationHistory } from "@/services/ApplicationHistoryService";

interface Vacancy {
    id: UUID;
    businessUnitId: UUID;
}

interface JobApplyProps {
    selectedItem: Vacancy | null;
    onClose: () => void;
    showCancel: boolean;
}


const JobApply: React.FC<JobApplyProps> = ({ selectedItem, onClose, showCancel}) => {
    const { data: session } = useSession();
    const { addApplicationHistory } = useAddApplicationHistory();

    const [showApplyingPopup, setShowApplyingPopup] = useState(false);
    const [showApplyStatusPopup, setShowApplyStatusPopup] = useState(false);
    const [popupHeader, setPopupHeader] = useState<string>("");
    const [popupMessage, setPopupMessage] = useState<string>("");
    const [popupImgSrc, setPopupImgSrc] = useState<string>("");

    const handleApply = async () => {
        if (!selectedItem || !session?.user) {
            return;
        }
        const userId = session.user?.["id"];
        const vacancyId = selectedItem?.id;
        const businessUnitId = selectedItem.businessUnitId;
        if (!userId || !vacancyId || !businessUnitId) {
            setPopupMessage("Missing required fields for application");
            setShowApplyingPopup(false);
            setShowApplyStatusPopup(true);
            return;
        }
        try {
            const response = await addApplicationHistory(userId, vacancyId, businessUnitId);
            console.log(response)          
            if (response?.data.isSuccess) {
                setPopupHeader("Your application has been submitted successfully");
                setPopupMessage(response.data.message || "Application submitted successfully");
                setPopupImgSrc("/success-apply.svg");
            } else {
                setPopupHeader("Your application did not go through");
                setPopupMessage(response.data.message || "Failed to apply for the vacancy");
                setPopupImgSrc("/failed-apply-vacancy.svg");
            }
        } catch (error) {
            console.error("Failed to apply for the vacancy", error);
            setPopupMessage("An unexpected error occurred");
        } finally {
            setShowApplyingPopup(false);
            setShowApplyStatusPopup(true);
        }
    };
    
    const closePopup = () => {
        setShowApplyingPopup(false);
        setShowApplyStatusPopup(false);
        onClose();
    }

    useEffect(() => {
        if (selectedItem) {
            console.log(selectedItem.id);
            setPopupMessage("Your profile, containing all pertinent details and qualifications, will be submitted alongside your application for the specific position you've opted for");
            setShowApplyingPopup(true);
        }
    }, [selectedItem, session?.user]);

    return (
        <>
            {(showApplyingPopup && showCancel) ? (
                <ConfirmationPopup
                    header="Apply Confirmation"
                    message={popupMessage}
                    onConfirm={handleApply}
                    onCancel={() => router.push(`/profileDetail?showApplyButton=true&id=${selectedItem?.id}&businessUnitId=${selectedItem?.businessUnitId}`)}
                    confirmLabel="Submit Application"
                    cancelLabel="Check my Profile"
                    imageSrc="/confirmation-apply-vacancy.svg"
                    confirmBtnStyle={2}
                    cancelBtnStyle={1}
                    popupSize={1}
                    withRemovePopupBtn={closePopup}
                />
            ) : (<ConfirmationPopup
                header="Apply Confirmation"
                message={popupMessage}
                onConfirm={handleApply}
                confirmLabel="Submit Application"
                cancelLabel="Check my Profile"
                imageSrc="/confirmation-apply-vacancy.svg"
                confirmBtnStyle={3}
                cancelBtnStyle={1}
                popupSize={1}
                withRemovePopupBtn={closePopup}
            />)}

            {showApplyStatusPopup && (
                <ConfirmationPopup
                    header={popupHeader}
                    message={popupMessage}
                    onConfirm={() => router.push("/application-history")}
                    onCancel={() => {
                        router.push("/vacancy");
                        closePopup();
                    }}
                    confirmLabel="Go to Application History"
                    cancelLabel="Back to Vacancy"
                    imageSrc={popupImgSrc}
                    confirmBtnStyle={1}
                    cancelBtnStyle={4}
                    popupSize={1}
                    withRemovePopupBtn={closePopup}
                />
            )}
        </>
    );
};

export default JobApply;